var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrustWorthy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.6663 23.9999C50.6663 27.8666 49.5197 31.4133 47.5463 34.3733C44.6663 38.64 40.1063 41.6533 34.7997 42.4266C33.893 42.5866 32.9597 42.6666 31.9997 42.6666C31.0397 42.6666 30.1063 42.5866 29.1997 42.4266C23.893 41.6533 19.333 38.64 16.453 34.3733C14.4797 31.4133 13.333 27.8666 13.333 23.9999C13.333 13.6799 21.6797 5.33325 31.9997 5.33325C42.3197 5.33325 50.6663 13.6799 50.6663 23.9999Z",
    stroke: "#007ECA",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M56.6666 49.2533L52.2666 50.2932C51.2799 50.5332 50.5066 51.2799 50.2932 52.2666L49.3599 56.1866C48.8532 58.3199 46.1332 58.9599 44.7199 57.2799L31.9999 42.6666L19.2799 57.3066C17.8666 58.9866 15.1466 58.3465 14.6399 56.2132L13.7066 52.2932C13.4666 51.3065 12.6932 50.5332 11.7332 50.3199L7.33322 49.2799C5.30655 48.7999 4.58655 46.2666 6.05322 44.7999L16.4532 34.3999C19.3332 38.6666 23.8932 41.68 29.1999 42.4533C30.1066 42.6133 31.0399 42.6933 31.9999 42.6933C32.9599 42.6933 33.8932 42.6133 34.7999 42.4533C40.1066 41.68 44.6666 38.6666 47.5466 34.3999L57.9466 44.7999C59.4132 46.2399 58.6932 48.7733 56.6666 49.2533Z",
    stroke: "#007ECA",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M33.5463 15.9467L35.1196 19.0934C35.3329 19.5201 35.8929 19.9467 36.3996 20.0267L39.2529 20.5067C41.0663 20.8001 41.4929 22.1334 40.1863 23.4401L37.9729 25.6534C37.5996 26.0267 37.3863 26.7467 37.5196 27.2801L38.1596 30.0267C38.6663 32.1867 37.5196 33.04 35.5996 31.8934L32.9329 30.32C32.4529 30.0267 31.6529 30.0267 31.1729 30.32L28.5063 31.8934C26.5863 33.0134 25.4396 32.1867 25.9463 30.0267L26.5863 27.2801C26.6929 26.7734 26.5063 26.0267 26.1329 25.6534L23.9196 23.4401C22.6129 22.1334 23.0396 20.8267 24.8529 20.5067L27.7063 20.0267C28.1863 19.9467 28.7463 19.5201 28.9596 19.0934L30.5329 15.9467C31.3063 14.2401 32.6929 14.2401 33.5463 15.9467Z",
    stroke: "#007ECA",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustWorthy);
export default __webpack_public_path__ + "static/media/TrustWorthy.e9c6c3344b38f78c71dbbb016f6f1fc9.svg";
export { ForwardRef as ReactComponent };